export enum UserState {
    Approve = 1,
    Rejected = 2,
    WaitingFor = 3,
}
